import useRoleAccess, { RoleAbilityProp } from './useRoleAccess'

const useAbilityAccess = (abilities: RoleAbilityProp): boolean => {
  return useRoleAccess(undefined, abilities)
}

export default useAbilityAccess
